import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '../../../../contexts/AuthContext';
import { Unauthorized } from '../../../../components/Unauthorized';
import { Chart } from '../../../../types/Chart/Chart';
import useChart from '../../../../hooks/useChart';
import { PatientDoc } from '../../../../types/Patient/PatientDoc';
import usePatientDoc from '../../../../hooks/usePatientDoc';
// import { NavBack } from '../../../../components/buttons/NavBack';
import { NavForward } from '../../../../components/buttons/NavForward';
// import { Header } from '../../../../components/header/Header';
import { getNextPage } from '../../../../data/navigation/getNextPage';
import { markPreviousPageCompleted } from '../../../../data/navigation/utilities/markPreviousPageCompleted';

export const Route = createFileRoute('/_authenticated/$patientId/package/learn')({
  component: LearnPage,
});

function LearnPage() {
  const { patientId } = Route.useParams<{ patientId: string }>();
  const { currentUser } = useAuth();
  const chartQuery = useChart(patientId);
  const chart = chartQuery.data as Chart;
  const patientDocQuery = usePatientDoc(patientId);
  const patientInfo = patientDocQuery.data as PatientDoc;
  const [nextPageURL, setNextPageURL] = React.useState<string | undefined>(undefined);

  // MARK PREVIOUS PAGE AS COMPLETED
  React.useEffect(() => {
    if (patientInfo && patientInfo.navObj) {
      markPreviousPageCompleted({ currentPageName: 'learn', patientInfo, value: true });
    }
  }, [patientInfo]);

  // GET NEXT PAGE URL
  React.useEffect(() => {
    if (chart && patientInfo?.navObj) {
      (async () => {
        const awaitedUrl = await getNextPage({
          currentPage: 'learn',
          chart: chart,
          patientInfo: patientInfo,
        });
        setNextPageURL(awaitedUrl);
      })();
    }
  }, [chart, patientInfo]);

  if (chartQuery.isLoading || !chart) {
    return <div>Loading patient information...</div>;
  }
  if (!currentUser) {
    return <div>Loading current user</div>;
  }
  if (currentUser?.uid !== patientId) {
    return <Unauthorized />;
  }
  if (currentUser?.uid === patientId && chart?.PATIENT_INFO_1) {
    return (
      <>
        {/* <Header patientId={patientId} /> */}
        <div id="general-education-page" className="flex flex-col items-center justify-center text-xl">
          <p>Please watch this video that will assist you in making a decision on the next screen.</p>
          <div id="general-education-video-container" className="flex w-5/6 flex-row justify-around">
            {/* TODO: Add captions track and disable warning */}
            {/* eslint-disable-next-line */}
            <video id="patient-education-video" className="my-4 h-4/6 w-1/3" controls>
              <source
                src="https://storage.googleapis.com/mideoid-console-public/videos/instructional/Self%20guided%20vs%20clinician%20guided%20choice%20video.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div id="nav" className="flex flex-row">
            {/* {prevPage && <NavBack to={prevPage} />} */}
            {/* {nextPage && <NavForward to={nextPage} disabled={false} />} */}
            {nextPageURL && <NavForward to={nextPageURL} disabled={false} />}
          </div>
        </div>
      </>
    );
  }

  return <div>Loading...</div>;
}
